import React, { Component } from "react";
import { connect } from "react-redux";
import Frame from "../Frame";
import { finishApplication } from "../../actions";
import PropTypes from "prop-types";
class UownContract extends Component {

  receiveMessage = (event) => {
    const { finishApplication } = this.props
    if (event.data === "uown_success") {
      finishApplication();
    }
    return;
  }

  render() {
    const { contractUrl, hidden } = this.props
    return (
      <Frame
        contractUrl={contractUrl}
        hidden={hidden}
        onReceiveMessage={this.receiveMessage}
      />
    )
  }
}

UownContract.propTypes = {
  contractUrl: PropTypes.string
};

UownContract.defaultProps = {
  contractUrl: ""
};

const mapDistpatchToProps = dispatch => {
  return {
    finishApplication: values => dispatch(finishApplication(values))
  };
};

UownContract = connect(null, mapDistpatchToProps)(UownContract);

export default UownContract;
